 window.addEventListener('scroll', function () {
    const header = document.querySelector('.transparent-header');
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  function toggleMobileMenu() {
    const menu = document.getElementById("mobileMenu");
    menu.classList.toggle("open");
  }

  function toggleDropdown(event) {
    if (window.innerWidth < 768) {
      event.preventDefault();
      event.target.nextElementSibling.classList.toggle("open-dropdown");
    }
  }